import { render, staticRenderFns } from "./LeavesTakenListModal.vue?vue&type=template&id=372c319a&"
import script from "./LeavesTakenListModal.vue?vue&type=script&lang=js&"
export * from "./LeavesTakenListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports